<template>
    <segment-form @submit="createSegment" :title="$t('settings.segments.create.title')"/>
</template>
<script>
  import SegmentGroupService from 'src/services/SegmentGroupService';
  import SegmentForm from './SegmentForm';

  export default {
    name: 'segments-create',
    components: {
      SegmentForm
    },
    methods: {
      async createSegment(data) {
        await SegmentGroupService.create(data);
        this.$router.push({name: 'settings_segments-groups'})
      }
    }
  }
</script>
